import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92d60fd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "title-wrap" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-stats" }
const _hoisted_7 = { class: "stat" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-heart-fill" }, null, -1))
const _hoisted_9 = { class: "stat" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-star-fill" }, null, -1))


  import { Card } from "@/types/index"

  
export default /*#__PURE__*/_defineComponent({
  props: {
    card: null,
    movementClass: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["movement-wrapper", __props.movementClass])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", __props.card.type]),
      id: __props.card.id
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.card.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: __props.card.image
        }, null, 8, _hoisted_5),
        _createElementVNode("p", null, _toDisplayString(__props.card.text), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(__props.card.statA), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(__props.card.statB), 1)
        ])
      ])
    ], 10, _hoisted_1)
  ], 2))
}
}

})